<div class="spinner-area" [ngStyle]="{'height.px': height}">
  <div class="spinner" [ngStyle]="{'width.px': dimensions, 'height.px': dimensions}"></div>
</div>
